import { ValueOfKey } from '../../utils-types';

export const VIDEO_PAGE = {
  ACCOUNT_SETUP: 'ACCOUNT_SETUP',
  SWYMO_ACADEMY: 'SWYMO_ACADEMY',
  SCAN_IQ: 'SCAN_IQ',
  INBODY: 'INBODY',
  CHALLENGES: 'CHALLENGES',
  NUTRITION: 'NUTRITION',
  APP_VIDEO_LIBRARY: 'APP_VIDEO_LIBRARY',
  BUSINESS_CENTER: 'BUSINESS_CENTER',
} as const;

export type VideoPageType = ValueOfKey<typeof VIDEO_PAGE>;

type VideoPageTitle = {
  title: string | null;
  description: string | null;
};

export const VIDEO_PAGE_TITLES: Record<VideoPageType, VideoPageTitle> = {
  [VIDEO_PAGE.ACCOUNT_SETUP]: {
    title: null,
    description: null,
  },
  [VIDEO_PAGE.SWYMO_ACADEMY]: {
    title: 'Welcome to SWYMO Academy!',
    description: 'Explore video trainings to master the SWYMO platform',
  },
  [VIDEO_PAGE.SCAN_IQ]: {
    title: 'Welcome to ScanIQ!',
    description: 'Learn how to use and get the most out of ScanIQ',
  },
  [VIDEO_PAGE.INBODY]: {
    title: 'Welcome to InBody!',
    description: 'Understand and apply InBody data in your workflow',
  },
  [VIDEO_PAGE.CHALLENGES]: {
    title: 'Welcome to Challenges!',
    description: 'Learn how to run engaging and effective challenges',
  },
  [VIDEO_PAGE.NUTRITION]: {
    title: 'Welcome to Nutrition!',
    description: 'Watch tutorials and guides for the Nutrition solution',
  },
  [VIDEO_PAGE.APP_VIDEO_LIBRARY]: {
    title: 'Welcome to App Video Library!',
    description: 'Library of existing app videos',
  },
  [VIDEO_PAGE.BUSINESS_CENTER]: {
    title: 'Welcome to Business Center (CRM)!',
    description:
      'Manage clients, track activity, and organize your business in one place',
  },
};
